import { axiosHelper } from 'Services/AxiosHelper';
import { GetSeasonTicketPriceModel } from 'Models';
import { getSeasonTicketPriceReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'b2c.RIGetSeasonTicketPrice';

const getSeasonTicketPrice = async (params: getSeasonTicketPriceReqBodyData): Promise<GetSeasonTicketPriceModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default getSeasonTicketPrice;
